import {usePageProps} from 'context/unsafePageProps'

import {useIsHydrated} from '@daedalus/core/src/utils/react/hooks/useIsHydrated'

interface ServerSideRenderingFeatureFlagProps {
  children: React.ReactNode
}

export const ServerSideRenderingFeatureFlag = ({
  children
}: ServerSideRenderingFeatureFlagProps) => {
  const {experiments} = usePageProps()
  const isHydrated = useIsHydrated()

  const isProductionLikeEnvironment = ['prd', 'tst'].includes(
    process.env.NEXT_PUBLIC_ENV
  )

  const shouldRender =
    !isProductionLikeEnvironment || // Always SSR in non-production environments
    experiments['feature-server-side-rendering'] === 'b' || // Use the feature flag
    isHydrated // Always render in client-side

  if (shouldRender) {
    return <>{children}</>
  }

  return null
}
